import { render, staticRenderFns } from "./view-publish-dcisoftware.vue?vue&type=template&id=157a23dd&scoped=true&"
import script from "./view-publish-dcisoftware.vue?vue&type=script&lang=js&"
export * from "./view-publish-dcisoftware.vue?vue&type=script&lang=js&"
import style0 from "./view-publish-dcisoftware.vue?vue&type=style&index=0&id=157a23dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157a23dd",
  null
  
)

export default component.exports